export default __webpack_public_path__ + "static/media/ButterflyPage2.32d693d5.txt";